import * as _ from 'lodash';

import { ShoppingCartItem } from 'app/b2b-order/services/shopping-cart/types';
import { OrderSheetItem } from 'app/b2b-order/services/order-sheet/types';
import {
    calculateTotalAmountMapPerArticle,
    flattenMultiStoreArticle,
    getTotalPriceByItem
} from 'app/b2b-order/helpers/order';
import { formatPrice } from 'app/b2b-order/helpers/price';
import { PreorderArticle, PreorderArticleSize, PrepackForPreorder } from 'app/b2b-order/types/preorder';
import { ReorderArticle, ReorderArticleSize, ReorderPrepack } from 'app/b2b-order/types/reorder';

export function getTotalFormatedPriceByItem(orderArticle: ReorderArticle, preferredLanguage: string) {
    if (!orderArticle.price.purchasePrice) {
        return '--';
    }

    const totalPrice = getTotalPriceByItem(orderArticle);
    return formatPrice(totalPrice, orderArticle.price.currency, preferredLanguage);
}

export function calculateItemsTotalPrice(
    items: ShoppingCartItem[] | PreorderArticle[],
    itemsCurrency: string,
    storeId?: string
): number {
    const hasNoPrice = _.some(
        items as any,
        ({ price }) => !price.purchasePrice || _.toUpper(price.currency) !== itemsCurrency
    );

    if (hasNoPrice) {
        return -1;
    }

    const pricesPerArticle = _.map(items, (item) =>
        getTotalPriceByItem(flattenMultiStoreArticle(item as any, storeId))
    );
    return _.sum(pricesPerArticle);
}

export function getItemIdentifier({ brandId, styleGroupId, color }: ShoppingCartItem | OrderSheetItem) {
    return `${brandId}-${styleGroupId}-${color.colorGroupId}`;
}

export function getTotalSelectedAmount(article: ReorderArticle) {
    const totalSelectedAmountMap = calculateTotalAmountMapPerArticle(article);
    return _.sum(_.values(totalSelectedAmountMap));
}

/* eslint-disable no-redeclare */

export function getItemFromArticleWithKey(
    reorderArticle: ShoppingCartItem,
    gtinOrPrepackId: string
): ReorderArticleSize | ReorderPrepack;
export function getItemFromArticleWithKey(
    preorderArticle: PreorderArticle,
    gtinOrPrepackId: string
): PreorderArticleSize | PrepackForPreorder;
export function getItemFromArticleWithKey(
    article: ShoppingCartItem | PreorderArticle,
    gtinOrPrepackId: string
): ReorderArticleSize | ReorderPrepack | PreorderArticleSize | PrepackForPreorder;
export function getItemFromArticleWithKey(
    article: ShoppingCartItem | PreorderArticle,
    gtinOrPrepackId: string
): ReorderArticleSize | ReorderPrepack | PreorderArticleSize | PrepackForPreorder {
    type ArticleSizesType = Array<ReorderArticleSize | PreorderArticleSize>;
    type ArticlePrepacksType = Array<ReorderPrepack | PrepackForPreorder>;

    return (
        (article?.sizes as ArticleSizesType)?.find((size) => size.gtin === gtinOrPrepackId) ||
        (article?.prepacks as ArticlePrepacksType)?.find((prepack) => prepack._id === gtinOrPrepackId)
    );
}

/* eslint-enable no-redeclare */
